import { Component } from '@angular/core';
import { Observable, of } from "rxjs";
import {Equipment} from './equipment';
import {EquipmentSet} from './equipmentSet';
import {EquipmentType} from './equipmentType';
import {EQUIPMENT_TYPES} from './equipmentTypeList';
import {SET_LIST} from './equipmentSetList';
import {HERO_LIST} from './heroList';
import {JOB_SIGN_BONUS_LIST} from './jobSignBonusList';
import {Hero} from './hero';
import {UserSet} from './userSet';
import {StarStatLevel} from './starStatLevel';
import {Stats} from './stats';


declare var $: any;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {
	jobZodiacBonusList = JOB_SIGN_BONUS_LIST;
	equipTypes = EQUIPMENT_TYPES;
	addEquipType : EquipmentType = EQUIPMENT_TYPES[0];
	addEquip = new Equipment();
	rarities = ['Epic','Heroic','Rare','Good','Normal'];
	sets = SET_LIST;
	heroes = HERO_LIST;
	selectedHero:Hero=new Hero();

	weapons: Array<Equipment> = [];
	armors: Array<Equipment> = [];
	helmets: Array<Equipment> = [];
	necklaces: Array<Equipment> = [];
	rings: Array<Equipment> = [];
	boots: Array<Equipment> = [];
	artifact = {attack:0,health:0};
	
	tempWeapons: Array<Equipment> = [];
	tempArmors: Array<Equipment> = [];
	tempHelmets: Array<Equipment> = [];
	tempNecklaces: Array<Equipment> = [];
	tempRings: Array<Equipment> = [];
	tempBoots: Array<Equipment> = [];
	
	bestStatName='';
	bestStatMin='';
	statFilters = [];
	statBonuses:Array<EquipmentSet> = [];
	
	equipmentSetStats = [];
	equipmentSetFinal = [];
	
	combos = [];
	
	equipmentSets:UserSet[] = [];
	setName:string='';

	file:any;
	
	selectWeaponIdx:number=0;
	selectHelmetIdx:number=0;
	selectArmorIdx:number=0;
	selectNecklaceIdx:number=0;
	selectRingIdx:number=0;
	selectBootIdx:number=0;


	finalStats = new Stats();
	equipStats = new Stats();
	selectedStar = new StarStatLevel();
	selectedAwakening :number = 0;
	awakenStat = new Stats();
	statList = Object.getOwnPropertyNames(this.finalStats);
	bestStat:string = '';
	bestStatMaxEquip = 5;
	
	addFilter():void {
		this.statFilters.push({statName:this.bestStatName,statMin:this.bestStatMin,resultCnt:0});
	}
	
	generateBest():void {
		let bestStat = this.bestStat;
		this.combos=[];
		
		this.tempHelmets = this.helmets;
		this.tempWeapons = this.weapons;
		this.tempArmors = this.armors;
		this.tempNecklaces = this.necklaces;
		this.tempRings = this.rings;
		this.tempBoots = this.boots;
		
		let combos = []; // {stats:{}, idx:[]}
		
		this.statFilters.forEach(function(s){
			s.resultCnt=0;
		});
		
		this.tempHelmets  = this.findBest(this.tempHelmets,this.statFilters[0].statName,this.bestStatMaxEquip);
		this.tempWeapons   = this.findBest(this.tempWeapons,this.statFilters[0].statName,this.bestStatMaxEquip);
		this.tempArmors = this.findBest(this.tempArmors,this.statFilters[0].statName,this.bestStatMaxEquip);
		this.tempNecklaces  = this.findBest(this.tempNecklaces,this.statFilters[0].statName,this.bestStatMaxEquip);
		this.tempRings  = this.findBest(this.tempRings,this.statFilters[0].statName,this.bestStatMaxEquip);
		this.tempBoots  = this.findBest(this.tempBoots,this.statFilters[0].statName,this.bestStatMaxEquip);
		combos = this.generateAllCombos(this.tempWeapons,this.tempHelmets,this.tempArmors,this.tempNecklaces,this.tempRings,this.tempBoots,this.statFilters[0]);
		this.statFilters[0].resultCnt=combos.length;
		
		let matchesAll = [];
		
		combos.forEach(function(c){
			let passes = true;

			for (let i=1;i<this.statFilters.length;i++) {
				const filter = this.statFilters[i];
				if (!this.passesFilter(c.stats,filter)) {
					passes = false;
					break;
				} else {
					this.statFilters[i].resultCnt = this.statFilters[i].resultCnt+1;
				}
			}
			
			if (passes) {
				matchesAll.push(c);
			}

		},this);
		
		this.combos = matchesAll.sort((a,b) => (this.getNumber(a.stats[this.statFilters[0]]) < this.getNumber(b.stats[this.statFilters[0]])?1:-1));
		this.combos = this.combos.slice(0,500);
	}
	
	addBestSet(combo, idx):void {
	console.log("Adding best", combo, this.tempWeapons, this.tempHelmets, this.tempArmors, this.tempNecklaces, this.tempRings, this.tempBoots);
		let us:UserSet = new UserSet();
		us.name="combo"+idx;
		us.equipment = [this.tempWeapons[combo.idx[0]],this.tempHelmets[combo.idx[1]],this.tempArmors[combo.idx[2]],this.tempNecklaces[combo.idx[3]],this.tempRings[combo.idx[4]],this.tempBoots[combo.idx[5]]];
		
		if(!this.equipmentSets) {
			this.equipmentSets = [];
		}
		this.equipmentSets.push(us);
		this.combos[idx].added=true;
	}
	
	getArrayFromIdx(array,idx):Array<any> {
		const unique = idx.filter((v, i, a) => a.indexOf(v) === i);
		let newArr = [];
		
		unique.forEach(function(i) {
			newArr.push(array[i]);
		});
		
		return newArr;
	}
	
	generateAllCombos(bWeps,bHelms,bArmors,bNecks,bRings,bBoots,filter):Array<any> {
		let combos = [];
		for(let i=0;i<bWeps.length;i++) {
			for(let j=0;j<bHelms.length;j++) {
				for(let k=0;k<bArmors.length;k++) {
					for(let l=0;l<bNecks.length;l++) {
						for(let m=0;m<bRings.length;m++) {
							for(let n=0;n<bBoots.length;n++) {
								const finalStats = this.addAllStats([bWeps[i],bHelms[j],bArmors[k],bNecks[l],bRings[m],bBoots[n]]);
								
								if (this.passesFilter(finalStats,filter)) {
									combos.push({stats:finalStats,idx:[i,j,k,l,m,n]});
								}
							}
						}
					}
				}
			}
		}
		
		return combos;
	}
	

	
	passesFilter(item,filter):boolean {
		let passed = true;
		if (item[filter.statName] < filter.statMin) {
			passed = false;
		}
		
		//console.log("checked " + filter.statName, item[filter.statName], filter.statMin,passed);
		return passed;
	}
	
	findBest(arr,statName,topNums):Array<any> {
		// we want to start with the topNums of the list, but then extend the last one to all equal values. ie. if array is 9,8,7,6,5,5,4 and topNums is 5. we want 9,8,7,6,5,5 and not 9,8,7,6,5
		let actualTop = topNums;
		//console.log("checking stat [" + statName + "] ", arr);
		const sortedArr = arr.sort((a,b) => (this.getNumber(a.stats[statName]) < this.getNumber(b.stats[statName])?1:-1));
		console.log("sorted",sortedArr);
		
		let topX = [];
		let lowestStat = 0;
		
		sortedArr.forEach(function(b){
			//console.log("processing ", b, statName);
			const statVal = this.getNumber(b.stats[statName]);
			
			if (topX.length < topNums) {
				topX.push(b);
			} else if (lowestStat === 0 ) {
				lowestStat = statVal;
			}
			if (lowestStat > 0 && statVal === lowestStat) {
				topX.push(b);
				actualTop++;
			}
		}, this);
		actualTop = actualTop - 1;
		
		let setName = '';
		this.sets.forEach(function(set) {
			//console.log("set",set.bonusStat,statName);
			if (set.bonusStat === statName) {
				setName = set.name;
			}
		});
		
		//console.log("setName",setName);
		for (let i=actualTop;i<sortedArr.length;i++) {
			if (sortedArr[i].set === setName) {
				topX.push(sortedArr[i]);
			}
		}
		
		//console.log("best find",topX);
		return topX;
	}
	
	addSet():void {
		let newSet:Array<Equipment> = [];
		newSet.push(this.weapons[this.selectWeaponIdx]);
		newSet.push(this.helmets[this.selectHelmetIdx]);
		newSet.push(this.armors[this.selectArmorIdx]);
		newSet.push(this.necklaces[this.selectNecklaceIdx]);
		newSet.push(this.rings[this.selectRingIdx]);
		newSet.push(this.boots[this.selectBootIdx]);
		
		let us:UserSet = new UserSet();
		us.equipment = newSet;
		if (this.setName) {
			us.name=this.setName;
		}
		
		if(!this.equipmentSets) {
			this.equipmentSets = [];
		}
		this.equipmentSets.push(us);
		//console.log("added set", us);
		
		this.setName='';
	}

	addEquipment():void {
		//console.log("Adding", this.addEquip);

		switch(this.addEquip.type) {
			case ("Weapon"): this.weapons.push(this.addEquip); break;
			case ("Helmet"): this.helmets.push(this.addEquip); break;
			case ("Armor"): this.armors.push(this.addEquip); break;
			case ("Necklace"): this.necklaces.push(this.addEquip); break;
			case ("Ring"): this.rings.push(this.addEquip); break;
			case ("Boot"): this.boots.push(this.addEquip); break;
		}

		//console.log("weapons", this.weapons);
		//console.log("armors", this.armors);

		this.addEquip = new Equipment();
		this.CalculateCurrentStats();
	}
	addEquipmentInit():void {
		this.addEquip = new Equipment();
	}
	
	showSet(i):void {
		const userSet = this.equipmentSets[i];
		
		let equipStats = this.addAllStats(userSet.equipment);
		let finalStats = this.calculateFinalStats(equipStats);
		
		this.equipmentSetStats.push({name:userSet.name,stats:equipStats});
		this.equipmentSetFinal.push({name:userSet.name,stats:finalStats});
	}
	removeSet(i):void {
		this.remove(this.equipmentSetStats,i);
		this.remove(this.equipmentSetFinal,i);
	}
	
	remove(arr,i):void {
		//console.log("remove", arr,i);
		arr.splice(i,1);
		
		this.CalculateCurrentStats();
	}
	
	edit(arr,i):void {
		//console.log("edit",arr,i);
		this.addEquip = arr[i];
		this.addEquipType = this.equipTypes.filter(item => {
			return item.name === arr[i].type;
		})[0];
		$('#exampleModal').modal('show');
	}
	
	save():void {
		this.addEquip = new Equipment();
		this.CalculateCurrentStats();
	}

	selectWeapon(w):void {
		this.selectWeaponIdx = w;
		this.CalculateCurrentStats();
	}

	selectArmor(w):void {
		this.selectArmorIdx = w;
		this.CalculateCurrentStats();
	}

	selectNecklace(w):void {
		this.selectNecklaceIdx = w;
		this.CalculateCurrentStats();
	}

	selectRing(w):void {
		this.selectRingIdx = w;
		this.CalculateCurrentStats();
	}

	selectHelmet(w):void {
		this.selectHelmetIdx = w;
		this.CalculateCurrentStats();
	}

	selectBoot(w):void {
		this.selectBootIdx = w;
		this.CalculateCurrentStats();
	}
	
	selectHero():void {
		this.selectedStar = this.selectedHero.statsbyStar[0];
		this.selectAwakening(this.selectedAwakening);
		this.CalculateCurrentStats();
		
		this.updateSetStats();
	}
	
	updateSetStats():void {
		for(let i=0;i<this.equipmentSetFinal.length;i++) {
			this.equipmentSetFinal[i].stats = this.calculateFinalStats(this.equipmentSetStats[i].stats);
		}
	}
	
	selectStar(e):void {
		if (!e) {
			return;
		}
		this.selectedStar = e;
		this.CalculateCurrentStats();
		this.updateSetStats();
	}
	
	selectAwakening(n):void {
		//console.log("selected " + n);
		this.selectedAwakening = n;
		this.awakenStat = new Stats();
		
		let jobZodiacBonus = this.jobZodiacBonusList.filter(item => {
			return item.job === this.selectedHero.job;
		})[0].bonusStats;
		
		let bonusStatsList = jobZodiacBonus.filter(item => {
			return item.sign === this.selectedHero.zodiacSign;
		})[0].bonusStats;
		
		for(let i=0;i<n;i++) {
			this.addStats(this.awakenStat,bonusStatsList[i]);
		}

		this.CalculateCurrentStats();
		this.updateSetStats();
		//console.log("awaken stats", this.awakenStat);
	}
	

	addStats(dest,src):void{
		//console.log("addstats", dest, src);
		for (var property in src) {
			if (src.hasOwnProperty) {
				dest[property] = dest[property] + this.getNumber(src[property]);
			}
		}
	}
	
	CalculateCurrentStats():void {
		let equips:Equipment[] = [];
		
		equips.push(this.weapons[this.selectWeaponIdx]);
		equips.push(this.helmets[this.selectHelmetIdx]);
		equips.push(this.armors[this.selectArmorIdx]);
		equips.push(this.necklaces[this.selectNecklaceIdx]);
		equips.push(this.rings[this.selectRingIdx]);
		equips.push(this.boots[this.selectBootIdx]);
	
		this.equipStats = this.addAllStats(equips);
		this.finalStats = this.calculateFinalStats(this.equipStats);
	}
	
	addAllStats(equips):Stats {
		if (!equips[0]) {
			return new Stats();
		}
		this.statBonuses = [];
		let finalStats:Stats = new Stats();
		
		equips.forEach(function(equip) {
			if (equip) {
				this.addStats(finalStats, equip.stats);
			}
		}, this);
		
	
		// calculate bonus
		this.sets.forEach(function(currentSet) {
			const setCnt = this.getSetCnt(equips, currentSet.name);
			
			const completeSetCnt = setCnt/currentSet.requiredItems>>0;
			//console.log("complete set " + currentSet.name + " " + completeSetCnt);
			for(let i=0;i<completeSetCnt;i++) {
				this.statBonuses.push(currentSet);
			}
		},this);

		for (let i=0;i<this.statBonuses.length;i++) {
			finalStats[this.statBonuses[i].bonusStat] = finalStats[this.statBonuses[i].bonusStat] + this.statBonuses[i].bonusStatValue;

		}
		
		//console.log('final', finalStats);
		return finalStats;
	}
	
	calculateFinalStats(stats):Stats {
		let finalStats:Stats = new Stats();
		const baseHealth = Math.floor(this.selectedStar.stats.health * (1 + this.awakenStat.healthPct/100) + this.awakenStat.health); // round down
		finalStats.health = (baseHealth * (1 + stats.healthPct/100)) +  // equipment health pct
							stats.health + // equipment health
							this.getNumber(this.artifact.health); // artifact health
							
		const baseAttack = Math.floor(this.selectedStar.stats.attack * (1 + this.awakenStat.attackPct/100) + this.awakenStat.attack); // round down
		finalStats.attack = (baseAttack * (1 + stats.attackPct/100)) +  // equipment attack pct
							stats.attack + // equipment attack
							this.getNumber(this.artifact.attack); // artifact attack
							
		const baseDef = Math.floor(this.selectedStar.stats.defense * (1 + this.awakenStat.defensePct/100) + this.awakenStat.defense); // round down
		finalStats.defense = Math.floor(baseDef * (1 + stats.defensePct/100)) +  // equipment defense pct. roll down
							stats.defense; // equipment defense
							
		finalStats.speed = this.selectedStar.stats.speed + this.awakenStat.speed + (this.selectedStar.stats.speed * stats.speedPct)/100 + stats.speed;
		finalStats.critRatePct = this.selectedStar.stats.critRatePct + stats.critRatePct + this.awakenStat.critRatePct;
		finalStats.critDamagePct = this.selectedStar.stats.critDamagePct + stats.critDamagePct + this.awakenStat.critDamagePct
		finalStats.dualPct = this.selectedStar.stats.dualPct + stats.dualPct;
		finalStats.effectivenessPct = this.selectedStar.stats.effectivenessPct + stats.effectivenessPct + this.awakenStat.effectivenessPct;
		finalStats.resistancePct = this.selectedStar.stats.resistancePct + stats.resistancePct + this.awakenStat.resistancePct;
		
		return finalStats;
	}
	
	getSetCnt(equips, setName):number {
		let selectedSets = [];
		
		equips.forEach(function(equip) {
			selectedSets.push(equip.set);
		});

		return selectedSets.filter(item => {
			return item === setName;
		}).length;
	}
	
	getNumber(n):number {
		if (!n) return 0;
		if(n == NaN) return Number(n);
		return Number(n);
	}
	
	// ************************ File things
		
	private setting = {
		element: {
			dynamicDownload: null as HTMLElement
		}
	}

	fileChanged(e) {
		this.file = e.target.files[0];
	}

	fakeEquips() {
		return of({weapons:this.weapons,armors:this.armors,helmets:this.helmets,necklaces:this.necklaces,rings:this.rings,boots:this.boots,equipmentSets:this.equipmentSets});
	}

	downloadEquips() {
		this.fakeEquips().subscribe((res)=>{
			this.dyanmicDownloadByHtmlTag({
				fileName:'equips',
				text: JSON.stringify(res)
			})
		})
	}

	uploadDocument() {
		let fileReader = new FileReader();
		fileReader.onload = (e) => {
			let equipsIn;
			if (typeof fileReader.result === 'string') {
				equipsIn = JSON.parse(fileReader.result);

				this.weapons = equipsIn.weapons;
				this.helmets = equipsIn.helmets;
				this.armors = equipsIn.armors;
				this.necklaces = equipsIn.necklaces;
				this.rings = equipsIn.rings;
				this.boots = equipsIn.boots;
				this.equipmentSets = equipsIn.equipmentSets;

				this.CalculateCurrentStats();
				console.log("loaded Data",equipsIn);
			}
		}
		fileReader.readAsText(this.file);
	}

	private dyanmicDownloadByHtmlTag(arg: {fileName: string, text: string}) {
		if (!this.setting.element.dynamicDownload) {
			this.setting.element.dynamicDownload = document.createElement('a');
		}
		const element = this.setting.element.dynamicDownload;
		const fileType = arg.fileName.indexOf('.json') > -1 ? 'text/json' : 'text/plain';
		element.setAttribute('href', `data:${fileType};charset=utf-8,${encodeURIComponent(arg.text)}`);
		element.setAttribute('download', arg.fileName);

		var event = new MouseEvent("click");
		element.dispatchEvent(event);
	}
	
	// *****************************************
}
